export default function (cb: () => void) {
  const route = useRoute()

  watch(() => route.fullPath, cb)
}
